import classNames from "classnames";
import { FieldValue, fieldControlClass, fieldDescribedBy } from "./FieldValue";
import { PicklistFieldProps } from "./PicklistField.types";

/**
 * Picklist/select editable field. Options use the repo's existing
 * `{Key, Value}` shape (see `src/page/api`/`FormField.js`) so this
 * drops straight into real picklist data without a shape translation.
 */
export function PicklistField({
  label,
  name,
  value,
  options,
  onChange,
  disabled,
  required,
  placeholder = "Please select",
  hidePlaceholder = false,
  error,
  className,
  controlClassName,
  helpText,
}: PicklistFieldProps) {
  return (
    <FieldValue label={label} htmlFor={name} required={required} helpText={helpText} error={error} className={className}>
      <select
        id={name}
        aria-describedby={fieldDescribedBy(name, helpText, error)}
        aria-invalid={error ? true : undefined}
        name={name}
        className={classNames(
          fieldControlClass("form-select", error),
          controlClassName
        )}
        value={value ?? ""}
        onChange={(event) =>
          onChange(
            event.target.value === "" ? null : event.target.value
          )
        }
        disabled={disabled}
        required={required}
      >
        {!hidePlaceholder && (
          <option value="" disabled={required}>
            {placeholder}
          </option>
        )}
        {options.map((option) => (
          <option key={option.Key} value={option.Key}>
            {option.Value}
          </option>
        ))}
      </select>
    </FieldValue>
  );
}
